import { computed, Directive, input } from '@angular/core';

type ButtonSize = 'S' | 'M' | 'L';

export const enum FilledFlavor {
	BASIC = 'BASIC',
	PRIMARY = 'PRIMARY',
	WARNING = 'WARNING',
}

const BUTTON_CLASS_BY_SIZE: Record<ButtonSize, string> = {
	S: 'px-1.5 py-0.75 rounded-1 gap-0.75',
	M: 'px-2 py-1 rounded-1 gap-1',
	L: 'px-3 py-1 rounded-1 gap-1',
};

@Directive({
	selector: '[buttonFilled]',
	standalone: true,
	host: {
		class: 'text-m fc-white flex items-center justify-center    ',
		'[class.bg-270]': '!$disabled() && $flavorIsBasic()',
		'[class.hover-always:overlay-standard-hover-270]': '!$disabled() && $flavorIsBasic()',
		'[class.bg-primary-500]': '!$disabled() && $flavorIsPrimary()',
		'[class.hover:bg-primary-700]': '!$disabled() && $flavorIsPrimary()',
		'[class.bg-warn-500]': '!$disabled() && $flavorIsWarning()',
		'[class.hover:bg-warn-700]': '!$disabled() && $flavorIsWarning()',
		'[class.bg-fg-200]': '$disabled()',
		'[class]': '$sizeClasses()',
		'[attr.disabled]': '$disabled() ? "true" : null',
		style: '--spacing: 8px; transition: background-color 300ms, color 300ms;',
	},
})
export class ButtonFilledDirective {
	public readonly $flavor = input<FilledFlavor | `${FilledFlavor}`>(FilledFlavor.PRIMARY, {
		alias: 'flavor',
	});

	public readonly $size = input<ButtonSize>('M', { alias: 'size' });

	public readonly $disabled = input<boolean, boolean | 'true' | 'false'>(false, {
		alias: 'disabled',
		transform: (value) => {
			return `${value}` === `true`;
		},
	});

	protected readonly $sizeClasses = computed(() => {
		const size = this.$size();
		return BUTTON_CLASS_BY_SIZE[size] ?? '';
	});

	protected readonly $flavorIsBasic = computed(() => {
		return this.$flavor() === FilledFlavor.BASIC;
	});

	protected readonly $flavorIsPrimary = computed(() => {
		return this.$flavor() === FilledFlavor.PRIMARY;
	});

	protected readonly $flavorIsWarning = computed(() => {
		return this.$flavor() === FilledFlavor.WARNING;
	});
}
